import {AuthenticationService} from '../../../shared/services/authentication/authentication.service';
import {HomeComponent} from "./home.component";


export const HomeRoutes = [
    {
        path: 'home',
        component: HomeComponent
    }
]


// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/components/public/home/home.routes.ts